import axios from 'axios';
import _ from 'lodash';
// import moment from 'moment';
import { getTimeDiff, toDateString } from './util';
import {
  setAppInfo,
  loadFilesInProgress,
  loadFilesSuccess,
  loadFilesFailure,
  loadFilesFilteredSuccess,
  sendInfoSuccess,
  sendInfoFailure,
  setFileAttribute,
  setUsers,
  setUserInfo,
  setMilestones,
  setMilestoneId,
  setReviewAssigInfo,
  getOutputReviewStatusGroupSuccess,
  getDocReviewStatusGroupSuccess,
  removetReviewAssign,
  updateReviewAssignAllowDownload,
  updateFileReviewStatusSuccess,
  getReviewFilesSuccess,
  getSummaryOverallSuccess,
  getDocSummaryOverallSuccess,
  updateOutputFileStatusSuccess,
  getOutputFileTocInfoSuccess,
  updateStatusByRBSuccess,
  updateStatusByLPSuccess,
  updateOutputGroupDueDateSuccess,
  updateDocGroupDueDateSuccess,
  sendEmailSuccess,
  updateDocFileStatusSuccess,
  checkOutputFileRemoveSuccess,
  updateAdhocInfoSuccess,
  searchAdhocSuccess,
  loadAdhocControlValueSuccess,
  loadSupportSuccess,
  updateStudyListSuccess,
  updateMilestoneListSuccess,
  updateRelatedTaskListSuccess,
  getAdhocRequestSuccess,
  getAdhocRequestersSuccess,
  updateAdhocAttachmentsSuccess,
  removeAdhocAttachmentSuccess,
  updateAdhocImageSuccess,
  removeAdhocImageSuccess,
  updateReviewInfoSuccess,
  setSearchInfo,
} from './actions';
import setting from './setting';

export const getAppInfo = (data) => async (dispatch, getState) => {
  console.log('getAppInfo data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/app/info`;
    const response = await fetch(dataUrl);
    const data = await response.json();
    console.log('getAppInfo result:', data);
    dispatch(setAppInfo(data));
  } catch(e) {
    console.log('Error in getAppInfo', e);
  }
}

// /review/output_file/check/remove
export const checkOutputFileRemove = (data, dispatch, getState) => {
  console.log('checkOutputFileRemove data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/output_file/check/remove`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> checkOutputFileRemove result:', result);
        dispatch(checkOutputFileRemoveSuccess(result));
      }, error => {
        // console.log('>>> checkOutputFileRemove:', error);
      }
    );
  } catch(e) {
    // dispatch(loadFilesFailure());
  }
}

// {program: "BT002", study: "201", milestone: "1st Interim Analysis", user: "jcao", groupId: "1"}
// allFiles: true - get all files, false - get only is_active files
export const loadFiles = (data) => async (dispatch, getState) => {
  data = data || {};
  try {
    dispatch(loadFilesInProgress());
    const dataFilesUrl =
      `${setting.annotation_server}/review/output/files?` +
      `program=${data.program}&study=${data.study}&` +
      `milestone=${data.milestone}&userId=${data.user}&` +
      `groupId=${data.groupId}&allFiles=${data.allFiles}`;
    const response = await fetch(dataFilesUrl);
    let files = await response.json();
    // console.log('loadFiles:', files);
    // need to add isComplete to false to avoid uncontrolled Switch component
    files = _.map(files, function(file) {
      file.isComplete = false;
      // file.isSelected = file.fileName === data.fileName;
      return file;
    });
    // console.log('>>> thunks loadFiles files:', files);
    dispatch(loadFilesSuccess(files));
    dispatch(loadFilesFilteredSuccess({files}));
    // set selected file in files when fileName is in data
    // console.log('set selected file:', { fileName: data.fileName, isSelected: true });
    if (data.fileName) {
      setTimeout( function() {
        dispatch(setFileAttribute({
          fileName: data.fileName,
          isSelected: true,
        }));
      }, 500);
    }
    // getReviewFiles
    const dataReviewFilesUrl = `${setting.annotation_server}/review/files?` +
      `userId=${data.user}&groupId=${data.groupId}`;
    console.log('getReviewFiles url:', dataReviewFilesUrl);
    axios.get(dataReviewFilesUrl)
      .then(res => {
        const result = res.data;
        // console.log('>>> getReviewFiles result:', result);
        dispatch(getReviewFilesSuccess(result));
      }, error => {
        console.log('error on getReviewFiles:', error);
      }
    );
    // getOutputFileTocInfo
    const dataTocInfoUrl = `${setting.annotation_server}/review/output_file/toc/info?` +
      `program=${data.program}&study=${data.study}&milestone=${data.milestone}`;
    console.log('dataTocInfoUrl url:', dataTocInfoUrl);
    axios.get(dataTocInfoUrl)
      .then(res => {
        const result = res.data;
        // console.log('>>> getOutputFileTocInfo result:', result);
        dispatch(getOutputFileTocInfoSuccess(result));
      }, error => {
        console.log('error on getOutputFileTocInfo:', error);
      }
    );
  } catch(e) {
    dispatch(loadFilesFailure());
  }
}

// {program: "BT002", study: "201", milestone: "1st Interim Analysis", user: "jcao", groupId: "1"}
export const loadDocFiles = (data) => async (dispatch, getState) => {
  data = data || {};
  try {
    dispatch(loadFilesInProgress());
    // console.log('>>>> loadDocFiles data:', data);
    const dataFilesUrl =
      `${setting.annotation_server}/review/doc/files?` +
      `program=${data.program}&study=${data.study}&` +
      `milestone=${data.milestone}&userId=${data.user}&groupId=${data.groupId}`;
    // console.log('>>> loadDocFiles dataFilesUrl:', dataFilesUrl);
    const response = await fetch(dataFilesUrl);
    let files = await response.json();
    files = _.map(files, (file) => {
      file.pagesReviewed = file.pagesReviewed ? file.pagesReviewed : 0;
      return file;
    });
    // console.log('>>>> loadDocFiles:', files);
    // need to add isComplete to false to avoid uncontrolled Switch component
    // files = _.map(files, function(file) {
    //   file.isComplete = false;
    //   // file.isSelected = file.fileName === data.fileName;
    //   return file;
    // });
    // console.log('>>> thunks loadFiles files:', files);
    dispatch(loadFilesSuccess(files));
    // set selected file in files when fileName is in data
    console.log('set selected file:', {
      fileName: data.fileName,
      isSelected: true,
    });
    if (data.fileName) {
      setTimeout( function() {
        dispatch(setFileAttribute({
          fileName: data.fileName,
          isSelected: true,
        }));
      }, 500);
    }
    // getReviewFiles
    const dataReviewFilesUrl = `${setting.annotation_server}/review/files?` +
      `userId=${data.user}&groupId=${data.groupId}`;
    console.log('getReviewFiles url:', dataReviewFilesUrl);
    axios.get(dataReviewFilesUrl)
      .then(res => {
        const result = res.data;
        // console.log('>>> getReviewFiles result:', result);
        dispatch(getReviewFilesSuccess(result));
      }, error => {
        console.log('error on getReviewFiles:', error);
      }
    );
  } catch(e) {
    dispatch(loadFilesFailure());
  }
}

export const getOutputReviewStatusGroup = (groupId) => async (dispatch, getState) => {
  try {
    // const dataUrl = `${setting.bps_server}/api/${groupId}/reviewStatusGroup`;
    const dataUrl = `${setting.annotation_server}/review/output/reviewStatusGroup?groupId=${groupId}`;
    const response = await fetch(dataUrl);
    const data = await response.json();
    // console.log('>>> get output review status group result:', data && data[0]);
    dispatch(getOutputReviewStatusGroupSuccess(data && data[0]));
  } catch(e) {
    // dispatch(loadFilesFailure());
  }
}

export const getDocReviewStatusGroup = (groupId) => async (dispatch, getState) => {
  try {
    // const dataUrl = `${setting.bps_server}/api/${groupId}/reviewStatusGroup`;
    const dataUrl = `${setting.annotation_server}/review/doc/reviewStatusGroup?groupId=${groupId}`;
    const response = await fetch(dataUrl);
    const data = await response.json();
    // console.log('>>> get doc review status group result:', data && data[0]);
    dispatch(getDocReviewStatusGroupSuccess(data && data[0]));
  } catch(e) {
    // dispatch(loadFilesFailure());
  }
}

export const setOutputFileAttribute = (param) => async (dispatch, getState) => {
  try {
    // const files = await response.json();
    dispatch(setFileAttribute(param));
  } catch(e) {
    dispatch(loadFilesFailure());
  }
}

export const updateFileReviewStatus = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateFileReviewStatus data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/file/update`;
    console.log('updateFileReviewStatus url:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        // const result = res.data;
        // console.log('>>> updateFileReviewStatus result:', result);
        dispatch(updateFileReviewStatusSuccess(data));
      }, error => {
        console.log('error on updateFileReviewStatus:', error);
      }
    );
  } catch(e) {
    // dispatch(loadFilesFailure());
  }
}

export const getUsers = () => async (dispatch, getState) => {
 try {
   //const dataUrl = `${setting.bps_server}/api/users`;
   const dataUrl = `${setting.annotation_server}/api/user/users`;
   const response = await fetch(dataUrl);
   const data = await response.json();
   // console.log('>>> users result:', data);
   dispatch(setUsers(data));
 } catch(e) {
   // dispatch(loadFilesFailure());
 }
}

export const getUserInfo = (data) => async (dispatch, getState) => {
  data = data || {};
  const userId = data.userId;
  console.log('getUserInfo data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/api/user/${userId}/data`;
    const response = await fetch(dataUrl);
    const data = await response.json();
    // console.log('>>> getUserInfo result:', data);
    dispatch(setUserInfo(data));
  } catch(e) {
    // dispatch(loadFilesFailure());
  }
}

export const getMilestones = (data) => async (dispatch, getState) => {
  data = data || {};
  const program = data.program;
  const study = data.study;
  const userId = data.user;
  const groupId = data.groupId;
  try {
    // const milestonesUrl = `${setting.bps_server}/api/${program}/${study}/milestones`;
    const milestonesUrl = `${setting.annotation_server}/study/${program}/${study}/milestones`;
    const milestonesResponse = await fetch(milestonesUrl);
    const milestones = await milestonesResponse.json();
    dispatch(setMilestones(milestones));
    dispatch(setMilestoneId(milestones));
    let milestone = _.find(milestones, { milestone:data.milestone });
    let milestoneId = milestone ? milestone.milestoneId : '';
    // get milestoneUserRole
    // const dataUseRoleUrl = `${setting.bps_server}/api/${milestoneId}/${userId}/milestoneUserRole`;
    const dataUseRoleUrl = `${setting.annotation_server}/study/group/${groupId}/user/${userId}/role?milestoneId=${milestoneId}`;
    // console.log('--> dataUseRoleUrl:', dataUseRoleUrl);
    const userRoleResponse = await fetch(dataUseRoleUrl);
    let userRoleData = await userRoleResponse.json();
    switch (userRoleData.userRole) {
      case 'Both':
        userRoleData.is_lp = true;
        userRoleData.is_rb = true;
        break;
      case 'Bio':
        userRoleData.is_lp = false;
        userRoleData.is_rb = true;
        break;
      case 'LP':
        userRoleData.is_lp = true;
        userRoleData.is_rb = false;
        break;
      default:
        userRoleData.is_lp = false;
        userRoleData.is_rb = false;
    }
    // get reviewers
    // https://testing-bps.viitai.com:8443/api/1/2/reviewers
    // https://localhost:9090/reviewer/get?groupId=12&milestoneId=4
    let dataReviewersUrl = `${setting.annotation_server}/reviewer/get?` +
      `groupId=${groupId}&milestoneId=${milestoneId}`;
    // console.log('--> dataReviewersUrl:', dataReviewersUrl);
    const reviewersResponse = await fetch(dataReviewersUrl);
    let reviewerItems = await reviewersResponse.json();
    // console.log('--> dataReviewersUrl reviewerItems:', JSON.stringify(reviewerItems, null, 2));
    let reviewers = _.map(reviewerItems, (reviewerItem) => {
      let allowDownload = reviewerItem.allow_download ? true : false;
      return {
        userId: reviewerItem.reviewerId,
        selected: false,
        allowDownload: allowDownload
      };
    });
    let reviewerUserCurrent = _.filter(reviewers, reviewer => reviewer.userId === userRoleData.userId);
    // console.log('>>> reviewerUserCurrent:', reviewerUserCurrent);
    if (reviewerUserCurrent.length === 1) {
      userRoleData.allowDownload = reviewerUserCurrent[0].allowDownload;
    }
    // console.log('>>> userRoleData:', userRoleData);
    dispatch(setUserInfo(userRoleData));
    dispatch(setReviewAssigInfo({reviewers}));
  } catch(e) {
    console.log('Error in getMilestones', e);
  }
}

// https://testing-bps.viitai.com:8443/api/BT001/101/1st%20Interim%20Analysis/2/yliu/reviewStatus
export const getUserReviewStatus = (data) => async (dispatch, getState) => {
  data = data || {};
  const milestone = data.milestone;
  // const milestoneId = data.milestoneId;
  const groupId = data.groupId;
  const userId = data.user;
  try {
    const dataUrl = `${setting.annotation_server}/api/user/reviewStatus?` +
      `groupId=${groupId}&userId=${userId}&` +
      `program=${data.program}&study=${data.study}&milestone=${milestone}`;
    // console.log('--> getUserReviewStatus dataUrl:', dataUrl);
    const response = await fetch(dataUrl);
    let statusItems = await response.json();
    // console.log('--> getUserReviewStatus statusItems:', statusItems);
    // filter out statusItem isDisabled = true
    if (statusItems) {
      statusItems = _.filter(statusItems, function(statusItem) {
        return !statusItem.isDisabled
      });
    }
    // console.log('--> getUserReviewStatus result:', statusItems);
    dispatch(setUserInfo({ reviewStatus:statusItems }));
  } catch(e) {
    console.log('Error in getUserReviewStatus:', e);
    // dispatch(loadFilesFailure());
  }
}

export const getSummaryOverall = (data) => async (dispatch, getState) => {
  data = data || {};
  // console.log('--> getSummaryOverall data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/summary/overall?groupId=${data.groupId}`;
    // console.log('--> getSummaryOverall dataUrl:', dataUrl);
    const response = await fetch(dataUrl);
    let result = await response.json();
    // console.log('--> getSummaryOverall result:', result);
    dispatch(getSummaryOverallSuccess(result));
  } catch(e) {
    // dispatch(loadFilesFailure());
  }
}

export const getDocSummaryOverall = (data) => async (dispatch, getState) => {
  data = data || {};
  // console.log('--> getDocSummaryOverall data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/doc/summary/overall?groupId=${data.groupId}`;
    // console.log('--> getDocSummaryOverall dataUrl:', dataUrl);
    const response = await fetch(dataUrl);
    let result = await response.json();
    // console.log('--> getDocSummaryOverall result:', result);
    dispatch(getDocSummaryOverallSuccess(result));
  } catch(e) {
    // dispatch(loadFilesFailure());
  }
}

export const submitCodeRequest = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('submitCodeRequest data:', data);
  try {
    // /api/user/send/code/:type/:userType/:userId/:value
    const dataUrl = `${setting.annotation_server}/api/user/send/code/` +
      `${data.type}/${data.userType}/${data.userId}/${data.value}`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('code sentd result:', result);
        dispatch(sendInfoSuccess({ infoSendStatus:'Verficiation code is sent successfully' }));
      }, error => {
        console.log('error:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'Failed to send verficiation code' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'Failed to send verficiation code' }));
  }
}

export const submitLoginRequest = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('submitLoginRequest data:', data);
  try {
    const loginUrl = `${setting.annotation_server}/api/user/login`;
    console.log('login url:', loginUrl);
    axios.post(loginUrl, data)
      .then(res => {
        const result = res.data;
        console.log('login result:', result);
        dispatch(sendInfoSuccess({ infoSendStatus:'Information is sent successfully' }));
      }, error => {
        console.log('error:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to send information' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to send information' }));
  }
}

// /api/1/2/dtjandra/yliu/addReviewer
// data: milestoneId, groupId, assignUserId, createUserId
export const addReviewAssignPost = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('addReviewAssignPost data:', data);
  let milestoneId = data.milestoneId || 0;
  try {
    // const dataUrl = `${setting.bps_server}/api/` +
    //   `${milestoneId}/${data.groupId}/${data.assignUserId}/${data.createUserId}/addReviewer`;
    const dataUrl = `${setting.annotation_server}/reviewer/add?` +
      `milestoneId=${milestoneId}&groupId=${data.groupId}&` +
      `userId=${data.assignUserId}&createUserId=${data.createUserId}`;
    axios.post(dataUrl)
      .then(res => {
        const result = res.data;
        console.log('addReviewAssignPost result:', result);
      }, error => {
        // cb(error, null);
        console.log('error:', error);
      }
    );
    // dispatch(loadFilesSuccess(files));
  } catch(e) {
  }
}

// https://testing-bps.viitai.com:8443/api/1/2/jcao/delReviewer
// data: milestoneId, groupId, userId
export const deleteReviewAssignPost = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('deleteReviewAssignPost data:', data);
  let milestoneId = data.milestoneId || 0;
  try {
    const dataUrl = `${setting.annotation_server}/reviewer/delete?` +
      `milestoneId=${milestoneId}&groupId=${data.groupId}&` +
      `userId=${data.userId}`;
    axios.post(dataUrl)
      .then(res => {
        const result = res.data;
        console.log('deleteReviewAssignPost result:', result);
        dispatch(removetReviewAssign(data.userId))
      }, error => {
        console.log('error:', error);
      }
    );
    // dispatch(loadFilesSuccess(files));
  } catch(e) {
  }
}

export const saveReviewAssignAllowDownloadPost = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('saveReviewAssignAllowDownloadPost data:', data);
  let milestoneId = data.milestoneId || 0;
  try {
    const dataUrl = `${setting.annotation_server}/reviewer/update?` +
      `milestoneId=${milestoneId}&groupId=${data.groupId}&` +
      `userId=${data.userId}&allow_download=${data.allowDownload}`;
    axios.post(dataUrl)
      .then(res => {
        // console.log('>>> saveReviewAssignAllowDownloadPost res:', res);
        // const result = res.data;
        // console.log('saveReviewAssignAllowDownloadPost data:', data);
        // console.log('saveReviewAssignAllowDownloadPost result:', result);
        dispatch(updateReviewAssignAllowDownload(data));
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

export const sendOutputInviteEmail = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('sendOutputInviteEmail data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/send_output_invite_email`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('sendOutputInviteEmail result:', result);
        dispatch(sendEmailSuccess(result));
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

export const sendDocInviteEmail = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('sendDocInviteEmail data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/send_doc_invite_email`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> sendDocInviteEmail result:', result);
        dispatch(sendEmailSuccess(result));
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

export const sendDocCancelEmail = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('sendDocCancelEmail data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/send_doc_cancel_email`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> sendDocCancelEmail result:', result);
        dispatch(sendEmailSuccess(result));
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

// https://testing-bps.viitai.com:8443/api/BT001/101/1st%20Interim%20Analysis/2/2/yliu/status
// /review/output_file/status/update
// data: program, study, milestone, filename, statusId
export const updateOutputFileStatus = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateOutputFileStatus data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/output_file/status/update`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('updateOutputFileStatus result:', result);
        dispatch(updateOutputFileStatusSuccess(data));
        checkOutputFileRemove(data, dispatch, getState);
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

export const updateDocFileStatus = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateDocFileStatus data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/doc_file/status/update`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('updateDocFileStatus result:', result);
        dispatch(updateDocFileStatusSuccess(data));
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

export const updateReviewerDocFileStatus = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateReviewerDocFileStatus data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/doc_file/reviewer/status/update`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('updateReviewerDocFileStatus result:', result);
        // dispatch(updateReviewerDocFileStatus(data));
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

// https://testing-bps.viitai.com:8443/api/BT002/201/1st%20Interim%20Analysis/1/undefined/Yes/jcao/updateByBio
// {program}/{study}/{milestone}/{groupId}/{outputFile}/{requireChange}/{userId}
// /review/output_file/status/update/rb
export const updateStatusByRB = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateStatusByRB data:', data);
  try {
    // const dataUrl = `${setting.bps_server}/api/` +
    //   `${data.program}/${data.study}/${data.milestone}/${data.groupId}/` +
    //   `${data.filename}/${data.requireChange}/${data.userId}/updateByBio`;
    const dataUrl = `${setting.annotation_server}/review/output_file/status/update/rb`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('updateStatusByRB result:', result);
        dispatch(updateStatusByRBSuccess(data));
        checkOutputFileRemove(data, dispatch, getState);
      }, error => {
        console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

// https://testing-bps.viitai.com:8443/api/BT002/201/1st%20Interim%20Analysis/1/undefined/Yes/jcao/updateByLP
// {program}/{study}/{milestone}/{groupId}/{outputFile}/{requireChange}/{userId}
// /review/output_file/status/update/lp
export const updateStatusByLP = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateStatusByLP data:', data);
  try {
    // const dataUrl = `${setting.bps_server}/api/` +
    //   `${data.program}/${data.study}/${data.milestone}/${data.groupId}/` +
    //   `${data.filename}/${data.requireChange}/${data.userId}/updateByLP`;
    const dataUrl = `${setting.annotation_server}/review/output_file/status/update/lp`;
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('updateStatusByLP result:', result);
        dispatch(updateStatusByLPSuccess(data));
        checkOutputFileRemove(data, dispatch, getState);
      }, error => {
        // console.log('error:', error);
      }
    );
  } catch(e) {
  }
}

// http://localhost:8090/review/output_file/toc/info?program=BT002&study=201&milestone=1st%20Interim%20Analysis
export const getOutputFileTocInfo = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('getOutputFileTocInfo data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/output_file/toc/info?` +
      `program=${data.program}&study=${data.study}&milestone=${data.milestone}`
    axios.get(dataUrl)
      .then(res => {
        const result = res.data;
        console.log('getOutputFileTocInfo result:', result);
        // dispatch(getOutputFileTocInfoSuccess(data))
      }, error => {
        console.log('getOutputFileTocInfo error:', error);
      }
    );
  } catch(e) {
  }
}

export const updateOutputGroupDueDate = (data) => async (dispatch, getState) => {
  data = data || {};
  console.log('updateOutputGroupDueDate data:', data);
  try {
    // const dataUrl = `${setting.bps_server}/api/` +
    //   `${data.program}/${data.study}/${data.milestone}/` +
    //   `${data.groupId}/${data.dueDate}/${data.userId}/duedate`;
    const dataUrl = `${setting.annotation_server}/review/output/group/duedate/update?` +
      `program=${data.program}&study=${data.study}&milestone=${data.milestone}&` +
      `groupId=${data.groupId}&dueDate=${data.dueDate}&userId=${data.userId}`;
    console.log('updateOutputGroupDueDate dataUrl:', dataUrl);
    axios.post(dataUrl)
      .then(res => {
        const result = res.data;
        console.log('updateOutputGroupDueDate result:', result);
        dispatch(updateOutputGroupDueDateSuccess(data));
      }, error => {
        console.log('Error in updateOutputGroupDueDate:', error);
      }
    );
  } catch(e) {
  }
}

export const updateDocGroupDueDate = (data) => async (dispatch, getState) => {
  data = data || {};
  console.log('updateDocGroupDueDate data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/doc/group/duedate/update?` +
      `program=${data.program}&study=${data.study}&milestone=${data.milestone}&` +
      `groupId=${data.groupId}&dueDate=${data.dueDate}&userId=${data.userId}`;
    console.log('updateDocGroupDueDate dataUrl:', dataUrl);
    axios.post(dataUrl)
      .then(res => {
        const result = res.data;
        console.log('updateDocGroupDueDate result:', result);
        dispatch(updateDocGroupDueDateSuccess(data));
      }, error => {
        console.log('Error in updateDocGroupDueDate:', error);
      }
    );
  } catch(e) {
  }
}

// https://localhost:9090/review/doc/review/status
export const getDocReviewStatus = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('getDocReviewStatus data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/review/doc/review/status`
    axios.get(dataUrl)
      .then(res => {
        const result = res.data;
        dispatch(setUserInfo({ reviewStatus:result }));
      }, error => {
        console.log('getDocReviewStatus error:', error);
      }
    );
  } catch(e) {
  }
}

export const requestPasswordReset = (data) => async (dispatch, getState) => {
  data = data || {};
  console.log('requestPasswordReset data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/user/password/reset?userId=${data.userId}`;
    console.log('requestPasswordReset dataUrl:', dataUrl);
    axios.post(dataUrl)
      .then(res => {
        const result = res.data;
        console.log('requestPasswordReset result:', result);
        dispatch(sendInfoSuccess({ infoSendStatus:'Password rest information is sent successfully' }));
      }, error => {
        console.log('Error in requestPasswordReset:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to send password reset information' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to send password reset information' }));
  }
}

export const requestPasswordChange = (data) => async (dispatch, getState) => {
  data = data || {};
  console.log('requestPasswordChange data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/user/password/change`;
    console.log('requestPasswordChange dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('requestPasswordChange result:', result);
        dispatch(sendInfoSuccess({
          infoSendStatus:' Your password has been changed successfully'
        }));
      }, error => {
        console.log('Error in requestPasswordChange:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to change password' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to change password' }));
  }
}

export const updateAdhocInfo = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateAdhocInfo data:', data);
  dispatch(updateAdhocInfoSuccess(data));
}

export const searchAdhoc = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('searchAdhoc data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/adhoc/search`;
    console.log('searchAdhoc dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('searchAdhoc result:', result);
        for (let i = 0; i < result.length; i++) {
          let record = result[i];
          record.turnaround_days = getTimeDiff(record.request_date, record.delivery_date);
          record.programming_days = getTimeDiff(record.programmer_request_date, record.programmer_complete_date);
          record.request_date = toDateString(record.request_date);
          record.delivery_date = toDateString(record.delivery_date);
          record.due_date = toDateString(record.due_date);
          record.programmer_request_date = toDateString(record.programmer_request_date);
          record.programmer_complete_date = toDateString(record.programmer_complete_date);
        }
        dispatch(searchAdhocSuccess({ records:result }));
        dispatch(setSearchInfo(data));
      }, error => {
        console.log('Error in searchAdhoc:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to search adhoc' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to search adhoc' }));
  }
}

export const addAdhoc = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('addAdhoc data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/adhoc/add`;
    console.log('addAdhoc dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('addAdhoc result:', result);
        let appState = getState();
        // console.log('>>> searchInfo:', appState.searchInfo);
        dispatch(searchAdhoc(appState.searchInfo));
      }, error => {
        console.log('Error in addAdhoc:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to add adhoc' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to add adhoc' }));
  }
}

export const updateAdhoc = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateAdhoc data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/adhoc/update`;
    console.log('updateAdhoc dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        console.log('updateAdhoc result:', result);
        let appState = getState();
        // console.log('>>> searchInfo:', appState.searchInfo);
        dispatch(searchAdhoc(appState.searchInfo));
      }, error => {
        console.log('Error in updateAdhoc:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to update adhoc' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to update adhoc' }));
  }
}

export const loadAdhocControlValues = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('loadAdhocControlValues data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/support/adhoc/controlvalues`;
    console.log('loadAdhocControlValues dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        let controlValue = _.groupBy(result, 'code_name');
        // console.log('controlValue:', JSON.stringify(controlValue, null, 2));
        dispatch(loadAdhocControlValueSuccess(controlValue));
      }, error => {
        console.log('Error in loadAdhocControlValues:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to load adhoc control values' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to load adhoc control values' }));
  }
}

export const loadSupport = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('loadSupport data:', data);
  try {
    // load programs
    const dataProgramUrl = `${setting.annotation_server}/support/programs`;
    console.log('loadSupport dataProgramUrl:', dataProgramUrl);
    axios.post(dataProgramUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> programs result:', JSON.stringify(result, null, 2));
        dispatch(loadSupportSuccess({ programs:result }));
      }, error => {
        console.log('Error in loadSupport:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to load support' }));
      }
    );
    // load all users
    const dataAllUserUrl = `${setting.annotation_server}/support/users`;
    console.log('loadSupport dataAllUserUrl:', dataAllUserUrl);
    axios.post(dataAllUserUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> users result:', JSON.stringify(result, null, 2));
        dispatch(loadSupportSuccess({ users:result }));
      }, error => {
        console.log('Error in loadSupport:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to load support' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to load support' }));
  }
}

export const updateStudyList = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateStudyList data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/support/studies`;
    console.log('updateStudyList dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> loadSupport result:', JSON.stringify(result, null, 2));
        dispatch(updateStudyListSuccess({ studies:result }));
      }, error => {
        console.log('Error in updateStudyList:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to update study list' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to update study list' }));
  }
}

export const updateMilestoneList = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('updateMilestoneList data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/support/milestones`;
    console.log('updateMilestoneList dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> loadSupport result:', JSON.stringify(result, null, 2));
        dispatch(updateMilestoneListSuccess({ milestones:result }));
      }, error => {
        console.log('Error in updateMilestoneList:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to update milestone list' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to update milestone list' }));
  }
}

export const updateRelatedTaskList = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('>>> updateRelatedTaskList data:', data);
  try {
    let dataUrl = `${setting.annotation_server}/support/related_tasks?`;
    if (data.program) {
      dataUrl += `program=${data.program}&`;
    }
    if (data.study) {
      dataUrl += `study=${data.study}&`;
    }
    if (data.milestone) {
      dataUrl += `milestone=${data.milestone}&`;
    }
    console.log('updateRelatedTaskList dataUrl:', dataUrl);
    axios.post(dataUrl, data)
      .then(res => {
        const result = res.data;
        // console.log('>>> loadSupport result:', JSON.stringify(result, null, 2));
        dispatch(updateRelatedTaskListSuccess({ relatedTasks:result }));
      }, error => {
        console.log('Error in updateRelatedTaskList:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to update related task list' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to update related task list' }));
  }
}

export const getAdhocRequest = (data) => (dispatch, getState) => {
  data = data || {};
  console.log('getAdhocRequest data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/adhoc/${ data.id }`;
    console.log('getAdhocRequest dataUrl:', dataUrl);
    axios.get(dataUrl, data)
      .then(res => {
        const result = res.data;
        let record = result[0];
        // console.log('>>> record', record);
        // console.log('>>> record.request_date', record.request_date);
        // console.log('>>> record.request_date 2', toDateString(record.request_date));
        // record.request_date = toDateString(record.request_date);
        // record.delivery_date = toDateString(record.delivery_date);
        // record.due_date = toDateString(record.due_date);
        // record.programmer_request_date = toDateString(record.programmer_request_date);
        // record.programmer_complete_date = toDateString(record.programmer_complete_date);
        dispatch(getAdhocRequestSuccess({ record:record }));
      }, error => {
        console.log('Error in getAdhocRequest:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to get adhoc request' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to get adhoc request' }));
  }
}

export const getAdhocRequesters = (data) => (dispatch, getState) => {
  data = data || getAdhocRequesters
  // console.log('getAdhocRequest data:', data);
  try {
    const dataUrl = `${setting.annotation_server}/adhoc/requesters`;
    console.log('getAdhocRequesters dataUrl:', dataUrl);
    axios.get(dataUrl, data)
      .then(res => {
        const result = res.data;
        dispatch(getAdhocRequestersSuccess({ records:result }));
      }, error => {
        console.log('Error in getAdhocRequesters:', error);
        dispatch(sendInfoFailure({ infoSendStatus:'failed to get adhoc requesters' }));
      }
    );
  } catch(e) {
    dispatch(sendInfoFailure({ infoSendStatus:'failed to get adhoc requesters' }));
  }
}

export const updateAdhocAttachments = (data) => (dispatch, getState) => {
  dispatch(updateAdhocAttachmentsSuccess(data));
}

export const removeAdhocAttachment = (data) => (dispatch, getState) => {
  dispatch(removeAdhocAttachmentSuccess(data));
}

export const updateAdhocImage = (data) => (dispatch, getState) => {
  dispatch(updateAdhocImageSuccess(data));
}

export const removeAdhocImage = (data) => (dispatch, getState) => {
  dispatch(removeAdhocImageSuccess(data));
}

export const updateFilesFiltered = (data) => (dispatch, getState) => {
  dispatch(loadFilesFilteredSuccess(data));
}

export const updateReviewInfo = (data) => (dispatch, getState) => {
  dispatch(updateReviewInfoSuccess(data));
}
